import { render, staticRenderFns } from "./Hotels.vue?vue&type=template&id=1fb63f94&scoped=true"
import script from "./Hotels.vue?vue&type=script&setup=true&lang=js"
export * from "./Hotels.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Hotels.vue?vue&type=style&index=0&id=1fb63f94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb63f94",
  null
  
)

export default component.exports